import { useAuth } from './AuthContext';
import { UserRole } from '@myscaw/shared';

const ALL_MANAGER_ROLES = [
  UserRole.PRESIDENT,
  UserRole.ADMIN,
  UserRole.ANNOUNCEMENT_MANAGER,
  UserRole.EVENT_MANAGER,
  UserRole.CARPOOLING_MANAGER,
  UserRole.CATERING_MANAGER,
  UserRole.ACADEMIC_MANAGER,
  UserRole.BOYS_DORMITORY_MANAGER,
  UserRole.GIRLS_DORMITORY_MANAGER,
];

const PRIVILEGED_ROLES = [UserRole.PRESIDENT, UserRole.ADMIN];

export function useIsAdmin(): boolean {
  const { user } = useAuth();
  if (!user) return false;
  return user.roles.some((role) => ALL_MANAGER_ROLES.includes(role as UserRole));
}

export function useCanManageUsers(): boolean {
  const { user } = useAuth();
  if (!user) return false;
  return user.roles.some((role) => PRIVILEGED_ROLES.includes(role as UserRole));
}
